export const failedPayment = {
  title: {
    letsCompletePayment: 'Completemos tu pago',
    sorryYourCardWasDeclined: 'Lo sentimos, tu tarjeta fue rechazada',
    pleaseUpdateYourPaymentMethod: 'Por favor actualiza tu método de pago',
    paymentReceived: 'Tu pago ha sido recibido',
  },
  label: {
    paymentFailed: 'Pago Fallido',
    missingPaymentMethod: 'Método de Pago Faltante',
    paymentIncomplete: 'Pago Incompleto',
    totalDue: 'Total Adeudado',
    paid: 'Pagado',
    notReady: '¿No estás listo para comenzar tu plan?',
    saveYourPlan: 'Guardaremos tu plan para cuando estés listo para suscribirte.',
    continueProgramPay: 'Para continuar con tu programa, por favor realiza el pago ahora.',
    updatePaymentContinue: 'Por favor actualiza tu método de pago para continuar con tu programa.',
  },
  actions: {
    makePayment: 'Realizar Pago',
    update: 'Actualizar',
    tryAgain: 'Intentar de Nuevo',
    callSupport: 'Llamar a Soporte',
    comeBackLater: 'Volver más tarde',
    completePayment: 'Completar pago',
    pay: 'Pagar',
  },
  errors: {
    failedToGetOrder: 'Error al obtener la información del pedido',
    failedToInitiatePay: 'Error al iniciar el pago',
    failedToProcessFlow: 'Error al procesar el flujo',
  },
};
